<template>
  <div>
    <Pos_add_promotion_new/>
  </div>
</template>

<script>
import Pos_add_promotion_new from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_add_promotion_new";
export default {
  name: "PosAddPromotionNew",
  components: {
    Pos_add_promotion_new
  }
}
</script>

<style scoped>

</style>
